import { ISelect } from '../SelectV2/types'

export enum CLASSNAME {
  TITLE = '.horizontalList__title',
  ACTIVE = '.horizontalList__active'
}

export interface OwnProps {
  defaultPattern: ISelect[]
  data?: ISelect[]
  selectedElements: any
  list: ISelect[]
  onHandleCustomFilters?: (isCustom: boolean) => void
}

export interface State {
  isOpenDropdown: boolean
  numberSelectedItems: number
  elements: ISelect[]
  defaultPattern: any
  isCaretOpen: boolean
}

export type Props = OwnProps